import React from "react";
import { FlightDetailsInfoDesktopUI } from "../../../../../../ui/FlightDetails/FlightDetailsInfo.desktop.ui.js";
import { PlaneTicketReturnIcon, MoneyIncomingIcon } from "@bookingcom/bui-assets-react/streamline";
import { Text } from "@bookingcom/bui-react";
export default function FareRulesInfoWithPartialsDesktop(props) {
    const { header, disclaimer, fareRules } = props;
    if (!fareRules?.length)
        return null;
    const iconsMap = {
        CHANGEABLE_TICKET: PlaneTicketReturnIcon,
        CANCELLABLE_TICKET: MoneyIncomingIcon
    };
    return (React.createElement(FlightDetailsInfoDesktopUI, null,
        React.createElement(FlightDetailsInfoDesktopUI.Title, null, header),
        fareRules?.map((rule) => (React.createElement(FlightDetailsInfoDesktopUI.Item, { key: rule.label, svg: iconsMap[rule.featureName] || rule.icon }, rule.label))),
        disclaimer ? React.createElement(Text, { variant: "small_1" }, disclaimer) : undefined));
}
